import React, { useState } from 'react';
import { useAuth } from '../../AuthContext';
import { useResolution } from '../../contexts/ResolutionContext';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

const ClaimAccountSection = () => {
	const { currentUser } = useAuth();
	const { person, showSuccess, showError } = useResolution();
	const [claimEmail, setClaimEmail] = useState('');
	const [isClaimLoading, setIsClaimLoading] = useState(false);

	const handleClaimAccount = async () => {
		if (!claimEmail) {
			return;
		}

		setIsClaimLoading(true);
		try {
			const claimAccountFunction = httpsCallable(functions, 'claimExistingAccount');
			const result = await claimAccountFunction({
				personId: person.id,
				email: claimEmail,
			});

			// If we reach here without error, assume success
			showSuccess('Verification email sent! Check your inbox to complete account claiming.');
			setClaimEmail('');
		} catch (error) {
			console.error('Error claiming account:', error);
			// Handle specific Firebase function errors
			if (error.code && error.message) {
				showError(error.message);
			} else {
				showError('Error claiming account');
			}
		} finally {
			setIsClaimLoading(false);
		}
	};

	// Don't render if user is already authenticated OR if account is already claimed
	if (currentUser || (person && person.authEnabled)) {
		return null;
	}

	// Don't render if person data isn't loaded yet
	if (!person) {
		return null;
	}

	return (
		<div className='bg-yellow-50 border border-yellow-200 p-4 rounded-lg mb-4'>
			<h3 className='font-semibold text-yellow-800 mb-2'>Secure Your Account</h3>
			<p className='text-yellow-700 mb-3 text-sm'>
				Claim this account to protect your resolutions and receive email updates. You'll receive a verification
				email to complete the process.
			</p>
			<div className='flex items-center space-x-2'>
				<input
					type='email'
					value={claimEmail}
					onChange={(e) => setClaimEmail(e.target.value)}
					placeholder='Enter your email to claim this account'
					className='flex-1 border border-gray-300 p-2 rounded text-sm'
					disabled={isClaimLoading}
				/>
				<button
					onClick={handleClaimAccount}
					disabled={isClaimLoading || !claimEmail}
					className='px-4 py-2 bg-blue-500 text-white rounded text-sm hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed'
				>
					{isClaimLoading ? 'Sending...' : 'Claim Account'}
				</button>
			</div>
		</div>
	);
};

export default ClaimAccountSection;
